import { Controller } from '@hotwired/stimulus'
import { Tooltip } from 'bootstrap'

export default class extends Controller {
  static values = { title: String }

  connect() {
    this.tooltipInstance = this.createTooltip()
  }

  createTooltip() {
    return new Tooltip(this.element, {
      title: this.titleValue,
      placement: this.element.dataset.tooltipPlacement || 'auto',
      trigger: 'hover',
      container: this.element,
      html: true,
      delay: { show: 100, hide: 100 },
    })
  }

  disconnect() {
    const tooltipInstance = Tooltip.getInstance(this.element)
    if (tooltipInstance) {
      tooltipInstance.dispose()
    }
  }
}
